import { ManagedApiError } from './ManagedHelpers';

export type LinkableAdminRow = {
    id: number;
    isLinked: boolean;
};

export const filterLinkedAdminRows = <T extends LinkableAdminRow>(
    rows: T[],
    hideUnlinked: boolean,
    searchText: string,
    matchesSearch: (row: T, lowerSearchText: string) => boolean
): T[] => {
    const lowerSearchText = searchText.toLocaleLowerCase();

    return rows.filter((row) => {
        return (!hideUnlinked || row.isLinked) && matchesSearch(row, lowerSearchText);
    });
};

export const updateLinkedAdminRow = <T extends LinkableAdminRow>(
    rows: T[],
    targetId: number,
    isLinked: boolean
): T[] => {
    return rows.map((row) => {
        if (row.id === targetId) {
            return {
                ...row,
                isLinked: isLinked,
            };
        }

        return row;
    });
};

export const buildLNKErrorMessage = (
    currentError: string,
    isLoadError: boolean,
    loadError: unknown,
    isMutationError: boolean,
    mutationError: unknown
): string => {
    if (isLoadError) {
        return currentError + ' ' + ((loadError as ManagedApiError).response?.data?.message ?? '');
    }

    if (isMutationError) {
        return currentError + ' ' + ((mutationError as ManagedApiError).response?.data?.message ?? '');
    }

    return '';
};
